import { useDispatch, useSelector } from "react-redux";
import { generalActions } from "redux/generalSlice";
import { showErrorModal } from "utils";
import api from "../api";
import useQuery from "./useQuery";

const useAuth = () => {
  const dispatch = useDispatch();
  const usuario = useSelector(state => state.general.usuario);
  
  const { loading } = useQuery({
    queryFn: api.auth.authenticate,
    onSuccess: (res) => {
      dispatch(generalActions.setUsuario(res?.data?.usuario));
    },
    onError: (err) => showErrorModal({ err }),
  });

  return {
    usuario,
    loading,
  };
};

export default useAuth;